export default {

  install(Vue: any) {
    Vue.prototype.dynamicBaseUrl = process.env.VUE_APP_DYNAMICFORM_API_PATH;
    Vue.prototype.dataCenterBaseUrl = process.env.VUE_APP_DATA_CENTER_API_PATH;
    Vue.prototype.dynamicAppKey = process.env.VUE_APP_DATA_CENTER_APPKEY;

    Vue.prototype.dynamicUploadConfig = {
      region: 'oss-cn-qingdao',
      accessKeyId: 'LTAI4Fk8j4o6gQWBQQZj7jhD',
      accessKeySecret: 'VOfFpbTgp9pjkSt6TRAnMaXKIK5ndp',
      bucket: 'lunz-test',
    };
  }
};